import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetailPage from "../pages/product/page";
import CheckoutPage from "../pages/checkout/page";
import CheckoutSuccessPage from "../pages/checkout/success";
import ArtisansPage from "../pages/artisans/page";
import CollectionPage from "../pages/collection/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/collections/:slug",
    element: <CollectionPage />,
  },
  {
    path: "/product/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/checkout/success/:orderId",
    element: <CheckoutSuccessPage />,
  },
  {
    path: "/artisans",
    element: <ArtisansPage />,
  },
  // legacy redirects
  {
    path: "/shop",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/shop/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/about",
    element: <ArtisansPage />,
  },
  {
    path: "/about/artisans",
    element: <ArtisansPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;